import { isNil, template } from 'lodash';

export const getAPIUrl = (API, platformDataCenter) =>
  template(API)({
    dc: !isNil(platformDataCenter) ? `-${platformDataCenter}` : '',
  });

export const getSevenHeaders = (config, headers = {}) => ({
  'HTTP-X-SEVEN-CLUB-UUID': config.tenantId,
  'HTTP-X-NAB-DP': config.applicationName,
  'SEVEN-LOCALE': config.locale,
  ...headers,
});

export const getNGSHeaders = (config, headers = {}) => ({
  'X-Nsft-Ngs-Product': config.productId,
  ...headers,
});
